// extracted by mini-css-extract-plugin
export default {"delete":"DeleteProjectModal_delete__zIXhR","action-btn":"DeleteProjectModal_action-btn__iub6h"};